export enum AttachmentTypeEnum
{
    TradingLicense = 1,
    RegistrationDocument = 2,
    AgencyLogo = 3,
    DrivingLicense = 4,
    IdintityCard = 5,
    Passport = 6,
    CarImage = 7,
    AgencyEmployeeImage = 8,
    AgencyEmployeeFile = 9,
    VehicleClassImg = 10,
    VehicleTypeImgExterior = 11,
    VehicleImage = 12,
    VehicleFile = 13,
    AccidentReportFile = 14,
    AccidentReportImage = 15,
    DamageReportFile = 16,
    DamageReportImage = 17,
    VehicleFinesFile = 18,
    NRMStartingSignature = 19,
    CorporateCustomer = 20,
    NRMEndSignature = 21,
    RepairCaseFile = 22,
    CustomerIndividualImage = 23,
    CustomerCorporateImage = 24,
    RequestCase = 25,
    ReleaseSignature = 26,
    ReceiveSignature = 27,
    MoveCancelRelease = 28,
    RepairCaseSignaturePickedupFromAgency = 29,
    RepairCaseSignatureReceivedByWorkshop = 30,
    RepairCaseSignaturePickedFromWorkshop = 32,
    RepairCaseSignatureReceivedByAgency = 33,
    RepairCaseSignatureCancelled = 34,
    AdditionalServicesIcon = 35,
    TheftCaseFile = 36,
    MemberShipBanners = 37,
    VehicleTypeImgInterior = 38,
    ReservationPikupSignature = 39,
    ReservationReturnSignature =40,
    Expenses = 41,
    RepairUploadSignedOffDeliveryFormByWS = 42 ,
    RepairUploadSignedOffDeliveryFormByAgency = 43,

    RefundSignature = 44,
    WriteoffSignature = 45,
    ExpenseSignature = 46,
    VehicleReservationCase = 47,
    PayablePayment = 48,
    ReconciliationSignature = 49,
    Reconciliation = 50,
    MaterialMoveDelivery = 51,
    MMYImage=53

}
export enum AttachmentScopesEnum
{
    AgencyRegistration = 1,
    CustomerRegistration = 2,
    Vehicle = 3,
    AgencyEmployee = 4,
    VehicleCase = 5,
    Customer = 6,
    Setting = 7,
    Campaign = 8,
    Financial = 9,
    Material = 10


}
